import http from '@/utils/http/http'

//账号密码登录
export function loginForPassword (data) {
  return http.post('/oauth/signin/password', data, {form: true})
}

//手机号登录
export function loginForSmsCode (data) {
  return http.post('/oauth/signin/smscode', data, {form: true})
}

//手机号注册
export function registForMobile(data) {
  return http.post('/oauth/signup/mobile', data, {form: true})
}

//手机号重置密码
export function resetPassForMobile(data) {
  return http.post('/oauth/reset/mobile', data, {form: true})
}

//电子邮件重置密码
export function resetPassForEmail(data) {
  return http.post('/oauth/reset/email', data, {form: true})
}

//用户登出
export function logout(data) {
  return http.get('/oauth/signout', data)
}